import theme from "../../../../../../packages/design-system/src/designTokens";
import Button from "../../../../../../packages/design-system/src/Button";
import Center from "../../../../../../packages/design-system/src/Center";
import * as React from 'react';
export default {
  theme,
  Button,
  Center,
  React
};